<div class="marketing-management">
    <div class="page-header">
        <h2 class="page-title">Market Buckets</h2>
        <button nz-button nzType="primary" (click)="openCreateModal()">
            <span nz-icon nzType="plus" nzTheme="outline"></span>
            Create New Bucket
        </button>
    </div>

    <nz-card class="table-card">
        <nz-table #bucketsTable [nzData]="buckets" [nzLoading]="loading" [nzFrontPagination]="false"
            [nzShowSizeChanger]="false" nzBordered>
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Priority</th>
                    <th>Created By</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let bucket of bucketsTable.data">
                    <td><strong>{{ bucket.name | titlecase }}</strong></td>
                    <td>{{ bucket.description || '—' }}</td>
                    <td>
                        <nz-tag [nzColor]="bucket.status === 'active' ? 'green' : 'default'">
                            {{ bucket.status | titlecase }}
                        </nz-tag>
                    </td>
                    <td>{{ bucket.priority }}</td>
                    <td>
                        {{ bucket.created_by_user?.first_name | titlecase }}
                        {{ bucket.created_by_user?.last_name | titlecase }}
                    </td>
                    <td class="actions-cell">
                        <button nz-button nzType="default" nzSize="small" (click)="openEditModal(bucket.id)">
                            <span nz-icon nzType="edit" nzTheme="outline"></span>
                            Edit
                        </button>
                        <button nz-button nzType="primary" nzDanger nzSize="small" nz-popconfirm
                            nzPopconfirmTitle="Are you sure? Markets in this bucket will become unassigned."
                            (nzOnConfirm)="deleteBucket(bucket.id)">
                            <span nz-icon nzType="delete" nzTheme="outline"></span>
                            Delete
                        </button>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </nz-card>
</div>

<!-- create modal -->
<nz-modal [nzVisible]="createModalVisible" [nzTitle]="createModalTitle" [nzContent]="createModalContent"
    [nzFooter]="createModalFooter" [nzWidth]="480" (nzOnCancel)="createModalVisible = false">
    <ng-template #createModalContent>
        <form [formGroup]="createForm" class="marketing-modal-form">
            <nz-form-item>
                <nz-form-label nzRequired>Name</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="name" placeholder="e.g. New bucket" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Description</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="description" placeholder="Brief description" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Status</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="status" nzPlaceHolder="Select status" class="full-width-select">
                        <nz-option *ngFor="let status of statusOptions" [nzValue]="status"
                            [nzLabel]="status | titlecase"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Position</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="placeAfter" nzPlaceHolder="Place after" class="full-width-select">
                        <nz-option *ngFor="let opt of positionOptions" [nzValue]="opt.value"
                            [nzLabel]="opt.label"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-template>
    <ng-template #createModalFooter>
        <button nz-button nzType="default" (click)="createModalVisible = false">Cancel</button>
        <button nz-button nzType="primary" (click)="createBucket(createForm.value)">Create</button>
    </ng-template>
</nz-modal>

<!-- edit modal -->
<nz-modal [nzVisible]="editModalVisible" [nzTitle]="editModalTitle" [nzContent]="editModalContent"
    [nzFooter]="editModalFooter" [nzWidth]="480" (nzOnCancel)="editModalVisible = false">
    <ng-template #editModalContent>
        <form [formGroup]="editForm" class="marketing-modal-form">
            <nz-form-item>
                <nz-form-label nzRequired>Name</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="name" placeholder="e.g. Bucket name" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label>Description</nz-form-label>
                <nz-form-control>
                    <input nz-input formControlName="description" placeholder="Brief description" />
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Status</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="status" nzPlaceHolder="Select status" class="full-width-select">
                        <nz-option *ngFor="let status of statusOptions" [nzValue]="status"
                            [nzLabel]="status | titlecase"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
            <nz-form-item>
                <nz-form-label nzRequired>Position</nz-form-label>
                <nz-form-control>
                    <nz-select formControlName="placeAfter" nzPlaceHolder="Place after" class="full-width-select">
                        <nz-option *ngFor="let opt of positionOptionsForEdit" [nzValue]="opt.value"
                            [nzLabel]="opt.label"></nz-option>
                    </nz-select>
                </nz-form-control>
            </nz-form-item>
        </form>
    </ng-template>
    <ng-template #editModalFooter>
        <button nz-button nzType="default" (click)="editModalVisible = false">Cancel</button>
        <button nz-button nzType="primary" (click)="editBucket(selectedBucket.id, editForm.value)">Save</button>
    </ng-template>
</nz-modal>